import React, { useEffect } from "react";
import "./SkillCom.scss";
import AOS from "aos";
import "aos/dist/aos.css";
import { sections } from "./skill-Item";

const SkillCom = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      debounceDelay: 50,
      once: false,
      mirror: true,
    });
  }, []);

  return (
    <section className="skill_cls section_padding">
      <div className="container skill_container">
        <div className="section_title txt_align skill_header" data-aos="fade-up">
          <h2>Skills</h2>
          <h4>Why Hire Me?</h4>
          <div className="line" />
        </div>

        <div className="skills_grid">
          {sections.map((section, sectionIndex) => (
            <article
              className="skill_category card"
              key={section.title}
              style={{ "--accent": section.accent }}
              data-aos="fade-up"
              data-aos-delay={sectionIndex * 120}
            >
              <header className="skill_category_header">
                <h3>{section.title}</h3>
              </header>

              <ul className="skill_chips">
                {section.data.map((item, index) => (
                  <li
                    className="skill_chip"
                    key={item.name}
                    data-aos="zoom-in"
                    data-aos-delay={sectionIndex * 120 + index * 30}
                  >
                    <div className="skill_chip_icon">
                      <img
                        src={item.img}
                        loading="lazy"
                        alt={`${item.name} icon`}
                      />
                    </div>
                    <span className="skill_chip_label">{item.name}</span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SkillCom;
